module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/ogp2-84e49c51e627d5ce2805bdcfb7296f47.png";